import React from 'react'
import cs from 'classnames'
import DateTimePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

import './style.sass'

type DatePickerProps = {
	className?: string
	onClearDate?: () => void
	standalone?: boolean
	value: Date | null
	onChange: (date: Date | null) => void
	inputProps?: {
		placeholder?: string
		className?: string
	}
}

const DatePicker: React.FC<DatePickerProps> = ({
	className = '',
	onClearDate = () => {},
	standalone,
	value,
	onChange,
	inputProps = {
		placeholder: '📅  21/12/2020',
		className: '',
	},
	...props
}) => {
	const cx = cs('DatePickerContainer--dateValueContainer', inputProps.className)
	return (
		<DateTimePicker
			onChange={onChange}
			isClearable
			{...props}
			selected={value}
			autoComplete={'off'}
			showTimeSelect
			timeFormat='HH:mm'
			timeIntervals={5}
			timeCaption='time'
			placeholderText={inputProps.placeholder}
			dateFormat='MMMM dd, yyyy HH:mm'
			className={cx}
		/>
	)
}

export default DatePicker
